import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { usePageMeta, useSite } from "@/lib/store";
import { renderBody } from "@/components/store/Icon";
import { WRAP } from "@/components/store/Chrome";
import { ProductGrid, SectionHeading } from "@/components/store/ProductCard";

const sectionLink = (s) =>
  s.type === "new" ? "/shop?sort=new&view=new" : s.type === "sale" ? "/shop?sale=1"
    : s.type === "genre" && s.genre ? `/shop?genre=${encodeURIComponent(s.genre)}` : "/shop";

export default function Home() {
  const { site } = useSite();
  const [sections, setSections] = useState(null);
  usePageMeta(site?.seo?.home_title, site?.seo?.home_description, site?.seo?.home_keywords);
  useEffect(() => {
    api.get("/home").then((r) => setSections(r.data));
  }, []);
  if (!site) return <div className="h-screen" />;
  return (
    <div className={WRAP}>
      <section className="pt-5 sm:pt-8 pb-4 sm:pb-7 grid lg:grid-cols-[1.3fr_1fr] gap-6 lg:gap-16 items-end">
        <h1 className="font-head font-extrabold tracking-[-0.04em] leading-[0.98] text-[30px] sm:text-5xl lg:text-[54px] rise" data-testid="home-headline">
          <span className="block">{site.headline1}</span>
          <span className="block text-red">{site.headline2}</span>
        </h1>
        <p className="hidden sm:block text-[#6b6b6b] text-base lg:text-[16px] leading-relaxed max-w-md lg:justify-self-end rise" style={{ animationDelay: "120ms" }} data-testid="home-intro">
          {site.intro}
        </p>
      </section>
      {sections === null && <div className="h-96 animate-pulse bg-white/60" />}
      {sections?.filter((s) => s.products.length).map((s) => (
        <section key={s.id} className="mb-20" data-testid={`home-section-${s.id}`}>
          <SectionHeading label={s.label} title={s.title} to={sectionLink(s)} id={`home-section-heading-${s.id}`} />
          <ProductGrid products={s.products} testid={`home-section-grid-${s.id}`} />
        </section>
      ))}
      {site.seo?.home_text && (
        <section className="border-t border-[#e0e0e0] pt-10 max-w-3xl prose-vrv text-[15px] text-[#555]" data-testid="home-seo-text">
          {renderBody(site.seo.home_text)}
        </section>
      )}
    </div>
  );
}
